// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"m4ECy","row":"_3xL-R","row-min-price":"_31bb-","rowMinPrice":"_31bb-","title":"_2jb8v","price":"_3unSn","minOrder":"_2dilG","total":"t4eVE"};